import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    genderHeading:{
        color:'#fe6b02',
        marginLeft:'4vw',
        fontWeight:'700',
        fontSize:'1.8rem',
        fontFamily:'Helvetica'
    },
    genderCarousel:{
        padding:'3vh 1vw',
        marginRight:'0.5%'
    }
}));

export default useStyles;